import { useUserStore } from '@/store'; // 确保路径正确
import { storeToRefs } from 'pinia';

const checkPermission = (el, binding, userInfo) => {
  // 检查元素是否已经有disabled属性且为true，如果是则不覆盖
  const hasDisabledAttr = el.hasAttribute('disabled');
  const isDisabledByAttr = hasDisabledAttr && el.disabled;
  
  // 如果元素已经被disabled属性禁用，则不进行权限检查的disabled设置
  if (isDisabledByAttr) {
    return;
  }

  if (binding.value) {
    if (
      userInfo.value.type != 1 &&
      userInfo.value.customRole &&
      !userInfo.value.customRole.split(',').includes('' + binding.arg) &&
      binding.value != userInfo.value.id
    ) {
      el.disabled = true;
      el.style.cursor = 'not-allowed';
    } else {
      el.disabled = false;
      el.style.cursor = '';
    }
  } else if (
    userInfo.value.type != 1 &&
    userInfo.value.customRole &&
    !userInfo.value.customRole.split(',').includes('' + binding.arg)
  ) {
    el.disabled = true;
    el.style.cursor = 'not-allowed';
  } else {
    el.disabled = false;
    el.style.cursor = '';
  }
};

export default {
  mounted(el, binding) {
    const store = useUserStore();
    const { userInfo } = storeToRefs(store);
    checkPermission(el, binding, userInfo);
  },
  updated(el, binding) {
    const store = useUserStore();
    const { userInfo } = storeToRefs(store);
    checkPermission(el, binding, userInfo);
  },
};